import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0 1rem 0;
  height: 100vh;
  width: 100%;
`;

export const ImageError = styled.img`
  width: 100%;
  max-width: 500px;
  margin: 0 0 -2rem;
`;
export const MessageError = styled.h4`
  margin: 0 0 2rem;
  text-align: center;
`;

